import * as React from "react";
let routerContext = React.createContext(null);
if (typeof document !== "undefined") {
  if (window.__TSR_ROUTER_CONTEXT__) {
    routerContext = window.__TSR_ROUTER_CONTEXT__;
  } else {
    window.__TSR_ROUTER_CONTEXT__ = routerContext;
  }
}
export {
  routerContext
};
//# sourceMappingURL=routerContext.js.map
